import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AllRoutes } from './index';
import ActionButton from '../bay-metal/helpers/ActionButton/ActionButton';
import { useSelector } from 'react-redux';
import NetworkHandler from '../bay-metal/helpers/noInternet/NetworkHandler';

const Routes = () => {
    const store = useSelector((state) => state);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const Loggedin = store?.Auth?.userLoggedIn;
    const currentPageURL = window.location.href;
    const currentPageName = currentPageURL
        .substring(currentPageURL.lastIndexOf('/') + 1)
        .replace(/\b\w/g, (c) => c.toUpperCase());

    useEffect(() => {
        return () => {
            if (currentPageName !== 'Add-Transactions' && currentPageName !== 'Transactions') {
                localStorage.removeItem('uniqueId');
                localStorage.removeItem('parentId');
                localStorage.removeItem('tagMessage');
            }
        };
    }, [currentPageURL, currentPageName]);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);
    return (
        <BrowserRouter>
            <NetworkHandler >
                <AllRoutes />
                {Loggedin !== false && currentPageName !== 'Logout' && isOnline ? <ActionButton /> : <></>}
            </NetworkHandler>
        </BrowserRouter>
    );
};

export default Routes;
